import {Component} from '@angular/core';
import {DialogRef} from "@fundamental-ngx/core/dialog";

@Component({
    selector: 'app-unified-creation-finished-yaml-confirmation-dialog',
    templateUrl: './unified-creation-finished-yaml-confirmation-dialog.component.html',
    styleUrls: ['./unified-creation-finished-yaml-confirmation-dialog.component.scss'],
    standalone: false
})
export class UnifiedCreationFinishedYamlConfirmationDialogComponent {

    isDownloadSelected = false;
    constructor(private _dialogRef: DialogRef) {}

    onClose() {
        this._dialogRef.close({isDownloadSelected: this.isDownloadSelected});
    }

}
